'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { eip5792Actions } from 'viem/experimental';

const getWalletCapabilities = (walletClient) => __awaiter(void 0, void 0, void 0, function* () { return walletClient.extend(eip5792Actions()).getCapabilities(); });

export { getWalletCapabilities };
